import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface HubState {
  masterVolume: number;
  isMuted: boolean;
  activeGameId: string | null;
  hapticsEnabled: boolean;
  reducedMotion: boolean;
  wishlist: string[];
  manualGames: string[];
  setMasterVolume: (v: number) => void;
  toggleMute: () => void;
  setActiveGame: (id: string | null) => void;
  setHaptics: (enabled: boolean) => void;
  setReducedMotion: (enabled: boolean) => void;
  toggleWishlist: (id: string) => void;
}

export const useHubStore = create<HubState>()(
  persist(
    (set) => ({
      masterVolume: 1.0,
      isMuted: false,
      activeGameId: null,
      hapticsEnabled: true,
      reducedMotion: false,
      wishlist: [],
      // Keep empty initially per user instruction, but seed with one game
      manualGames: ['screw-out-3d-relax-unwind-76621-gm'], 
      
      setMasterVolume: (v) => set({ masterVolume: v }),
      toggleMute: () => set((state) => ({ isMuted: !state.isMuted })),
      setActiveGame: (id) => set({ activeGameId: id }),
      setHaptics: (enabled) => set({ hapticsEnabled: enabled }),
      setReducedMotion: (enabled) => set({ reducedMotion: enabled }),
      toggleWishlist: (id) => set((state) => ({
        wishlist: state.wishlist.includes(id) 
          ? state.wishlist.filter(g => g !== id) 
          : [...state.wishlist, id]
      })),
    }),
    {
      name: 'hub-storage',
    }
  )
);

